import VideoTextBlockPreview from "./VideoTextBlockPreview";

export default VideoTextBlockPreview;